import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = `/website/<id>/content`;

export function getWebsiteContentListQueryKey({
	id,
	impersonationContext,
}: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
}) {
	return [BASE_QUERY_KEY, id, impersonationContext];
}

export function useWebsiteContentListQuery({
	id,
	impersonationContext,
	enabled,
}: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery<WebsiteContent[]>({
		enabled,
		queryKey: [BASE_QUERY_KEY, id, impersonationContext],
		queryFn: () =>
			userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `website/${id}/content`,
					impersonationContext,
				}),
				'GET'
			),
	});
}

export const invalidateWebsiteContentListQuery = ({ id }: { id: string }) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, id] });
};
